import { ref } from "vue";

/**
 * Hook générique pour manipuler une donnée réactive de type T
 * @param initialValue Valeur de départ
 * @returns {
 *   refData: Ref<T>,
 *   doChangeData: (newValue: T) => void
 * }
 */
function useData<T = any>(initialValue: T) {
  const refData = ref(initialValue);

  const doChangeData = (newValue: T) => {
    refData.value = newValue;
  };

  return {
    refData,
    doChangeData,
  };
}

export default useData;
